import { EntityModel } from '@/interfaces'
import {
  ALL_PAGE_HEADER_BLOCKS_QUERY,
  CREATE_PAGE_HEADER_BLOCK_MUTATION,
  DELETE_PAGE_HEADER_BLOCK_MUTATION,
  FORCE_DELETE_PAGE_HEADER_BLOCK_MUTATION,
  SINGLE_PAGE_HEADER_BLOCK_QUERY,
  UPDATE_PAGE_HEADER_BLOCK_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const cmsPageHeaderBlockModel: EntityModel = {
  name: 'pageHeaderBlock',
  namePlural: 'pageHeaderBlocks',
  uniqueName: 'cmsPageHeaderBlock',
  uniqueNamePlural: 'cmsPageHeaderBlocks',
  path: 'cms/blocks/page_header_block',
  baseUrl: '/cms/blocks/page_header_blocks',
  translationPrefix: 'entities:cmsPageHeaderBlock.',
  getDisplayName: (values: any) => {
    return 'Page Header Block'
  },
  gql: {
    getAll: ALL_PAGE_HEADER_BLOCKS_QUERY,
    getSingle: SINGLE_PAGE_HEADER_BLOCK_QUERY,
    create: CREATE_PAGE_HEADER_BLOCK_MUTATION,
    update: UPDATE_PAGE_HEADER_BLOCK_MUTATION,
    delete: DELETE_PAGE_HEADER_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_PAGE_HEADER_BLOCK_MUTATION,
  },
  attributes: {
    title: {
      name: 'title',
      label: 'entities:cmsPageHeaderBlock.attributes.title.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    text: {
      name: 'text',
      label: 'entities:cmsPageHeaderBlock.attributes.text.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    image: {
      name: 'image',
      label: 'entities:cmsPageHeaderBlock.attributes.image.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsPageHeaderBlockModel
